module.exports = __webpack_public_path__ + "img/fig10.15cf1cc1.jpg";